import React from 'react';
import {
  getSubCategoryId,
  operatorsList,
  select_operator_layout_key,
  select_operator_with_sim,
  select_operator_without_sim,
} from '../utils/DictionaryManagementUtils';
import SimulatorsViewerArrangement
  from '../components/SimulatorsComponents/FullPagesComponents/SimulatorsViewerArrangement';
import SelectOperatorFP
  from '../components/SimulatorsComponents/FullPagesComponents/Services/Operator/SelectOperatorFP';

const Sim_H08_TopUpSelectOperator = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { operator } = globJSON.configurations.services[subCategoryId];

  const numberColumns = operator.design_the_layout === select_operator_layout_key.column_1 ? 1 : 2;
  const headlineText = operator.select_mobile_operator_title;

  return (
    <SimulatorsViewerArrangement>
      <SelectOperatorFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        headlineText={headlineText}
        topTitle={select_operator_with_sim}
        operatorsList={operatorsList}
        numberColumns={numberColumns}
        enableScreen={operator.customer_should_select_a_mobile_operator}
        slideshowRefs={slideshowRefs}
      />
      <SelectOperatorFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        headlineText={headlineText}
        topTitle={select_operator_without_sim}
        operatorsList={operatorsList}
        numberColumns={numberColumns}
        enableScreen={operator.customer_should_select_a_mobile_operator}
        withIcon
        slideshowRefs={slideshowRefs}
      />
    </SimulatorsViewerArrangement>
  );
};

export default Sim_H08_TopUpSelectOperator;
